//import admin from './admin'
//import detail from './detail'
import grid from './grid'
import member from './member'
import temp from './temp'
import notice from './notice'
// import banner from './banner'
// import groupManage from './groupManage'
// import pushMsg from './pushMsg'
//import treeMenu from './treeMenu'
export default {
    //admin,
    //detail,
    grid,
    member,
    temp,
    notice,
    // banner,
    // groupManage,
    // pushMsg,
    //treeMenu,
}